export const initialState: State.PickListsState = {
  pickLists: {},
  loading: false,
  error: null,
};
